import React from 'react'

const MOVERS = [
  {
    tool: 'Wispr',
    cat: 'AI Tools · Voice-to-text AI',
    points: '2,24 18,22 34,19 50,16 66,12 82,8 98,4 118,2',
    growth: '+70%',
  },
  {
    tool: 'GetMyInvoices',
    cat: 'Finance & Accounting · Invoice automation',
    points: '2,24 18,22 34,20 50,16 66,13 82,9 98,6 118,3',
    growth: '+53%',
  },
  {
    tool: 'Granola',
    cat: 'AI Tools · AI meeting notes',
    points: '2,23 18,21 34,18 50,15 66,12 82,9 98,6 118,4',
    growth: '+46%',
  },
  {
    tool: 'Railway',
    cat: 'Cloud Infra · App deployment platform',
    points: '2,23 18,21 34,19 50,16 66,13 82,10 98,7 118,5',
    growth: '+43%',
  },
  {
    tool: 'Anthropic',
    cat: 'AI Tools · Remarkable for its scale',
    points: '2,22 18,20 34,18 50,16 66,14 82,11 98,8 118,6',
    growth: '+33%',
  },
  {
    tool: 'Fireflies',
    cat: 'AI Tools · Meeting transcription',
    points: '2,23 18,21 34,19 50,17 66,14 82,12 98,9 118,7',
    growth: '+32%',
  },
  {
    tool: 'Apify',
    cat: 'Dev Tools · Web scraping & automation',
    points: '2,23 18,21 34,20 50,17 66,15 82,12 98,10 118,8',
    growth: '+31%',
  },
  {
    tool: 'Netlify',
    cat: 'Cloud Infra · Web hosting platform',
    points: '2,23 18,22 34,20 50,18 66,15 82,13 98,10 118,8',
    growth: '+31%',
  },
]

const FastestMovers: React.FC = () => (
  <section id="movers" className="section white">
    <div className="wrap">
      <div className="subsection" style={{marginTop: 0}}>
        <div className="eyebrow eyebrow-dot" style={{marginBottom: 12}}>
          Fastest movers right now
        </div>
        <h3>Not the biggest, the fastest-growing. May 2026.</h3>
        <p className="sub-intro">
          Tools gaining the most month-over-month traction (May 2026 vs rolling 3-month average).{' '}
          <em>AI tools dominate again</em>, five of the top 8 are AI products, led by Wispr at +70%.
        </p>
      </div>
      <div className="movers-grid">
        {MOVERS.map((m) => (
          <div key={m.tool} className="mover">
            <div>
              <div className="tool">{m.tool}</div>
              <div className="cat">{m.cat}</div>
            </div>
            <svg className="spark" viewBox="0 0 120 28">
              <polyline fill="none" stroke="#185137" strokeWidth="2" strokeLinecap="round" points={m.points} />
            </svg>
            <div className="growth">{m.growth}</div>
          </div>
        ))}
      </div>
      <div className="cat-insight" style={{marginTop: 48}}>
        <strong>Five of the 8 fastest-growing tools</strong> in May 2026 are AI products. Anthropic at +33% is
        remarkable given its already-massive 1,044-org base, the renewed AI adoption wave has displaced the
        infrastructure vendors that led earlier in the cycle.
      </div>
    </div>
  </section>
)

export default FastestMovers
